import FuseUtils from '@fuse/utils';
import FuseLoading from '@fuse/core/FuseLoading';
import { Navigate } from 'react-router-dom';
import settingsConfig from 'app/configs/settingsConfig';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignUpConfig from '../main/sign-up/SignUpConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import AdminAppConfig from '../main/admin/AdminAppConfig';
import Error404Page from '../main/404/Error404Page';
import NotesAppConfig from '../main/admin/notes/NotesAppConfig';
import LandingConfig from '../main/landing/LandingConfig';

const routeConfigs = [SignOutConfig, SignInConfig, AdminAppConfig, SignUpConfig, NotesAppConfig, LandingConfig];
const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <Navigate to="/home" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Navigate to="404" />,
  },
 
];

export default routes;
